import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MediaFile } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private httpClient = inject(HttpClient);

  getFileByUrl(url: string): Observable<any> {
    const headers = new HttpHeaders({
      Range: 'bytes=0-1',
    });

    return this.httpClient.get(url, { headers, observe: 'response', responseType: 'blob' });
  }

  downloadMediaFile(mediaFile: MediaFile): void {
    fetch(mediaFile.link)
      .then((res) => res.blob())
      .then((blob: Blob) => {
        this.downloadBlob(blob, mediaFile.fileName);
      })
      .catch(() => {
        // Fallback when CORS prevents fetching the file as a Blob.
        this.openUrl(mediaFile.link);
      });
  }

  private downloadBlob(blob: Blob, fileName: string): void {
    const blobUrl = URL.createObjectURL(blob);
    this.triggerDownload(blobUrl, fileName);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 0);
  }

  private openUrl(url: string): void {
    this.triggerDownload(url);
  }

  private triggerDownload(url: string, fileName?: string): void {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.rel = 'noopener';

    if (fileName) {
      anchor.download = fileName;
    } else {
      anchor.target = '_blank';
    }

    anchor.style.display = 'none';
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
  }
}
